import React, { useState, useRef, useEffect } from 'react';
import { Globe, Check } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';

const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang, languages } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, []);

  const current = languages.find((l) => l.code === lang) || languages[0];

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        data-testid="lang-switcher-btn"
        aria-label="Change language"
        className={`flex items-center gap-1.5 rounded-full border border-[#D4AF37]/30 text-white/85 hover:text-[#D4AF37] hover:border-[#D4AF37]/60 transition-colors ${
          compact ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-[13px]'
        }`}
      >
        <Globe className={compact ? 'w-3 h-3' : 'w-3.5 h-3.5'} />
        <span className="font-medium">{current.label}</span>
      </button>

      {open && (
        <div
          className="absolute end-0 mt-2 min-w-[160px] bg-[#072A1F] border border-[#D4AF37]/25 rounded-xl shadow-2xl py-1.5 z-50"
          data-testid="lang-switcher-menu"
        >
          {languages.map((l) => {
            const active = l.code === lang;
            return (
              <button
                key={l.code}
                type="button"
                onClick={() => { setLang(l.code); setOpen(false); }}
                data-testid={`lang-option-${l.code}`}
                className={`w-full flex items-center justify-between gap-4 px-4 py-2 text-sm transition-colors ${
                  active ? 'text-[#D4AF37]' : 'text-white/80 hover:text-[#D4AF37] hover:bg-[#0B3D2E]'
                }`}
              >
                <span>{l.name}</span>
                {active && <Check className="w-4 h-4" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
